import React from 'react';
import AppointmentForm from '../../AppointmentForm';
import { Icon } from '@iconify/react';

export default function AppointmentWithContactInfoSection() {
  return (
    <section className="bg-cream-dark py-24 relative overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6 md:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-20">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4">
              <span className="w-[24px] h-px bg-gold block"></span>
              Book a Session
            </div>
            <h2 className="font-serif text-4xl md:text-[3.5rem] font-light leading-[1.2] text-charcoal mb-10">
              Appointment
            </h2>
            <AppointmentForm />
          </div>
          <div className="lg:col-span-5">
            <div className="bg-white p-8 md:p-12 rounded-md shadow-xl border border-cream h-full flex flex-col relative overflow-hidden">
               <div className="absolute top-0 right-0 w-32 h-32 bg-crimson/5 rounded-bl-[100px] pointer-events-none"></div>
               <img
                  src="/images/new/Mental health icon 21 Psychology talk.png"
                  alt="Appointment"
                  className="w-full h-auto aspect-video object-cover rounded mb-10 opacity-90"
                />
               <h3 className="font-serif text-2xl text-charcoal mb-8 border-b border-cream-dark pb-4">Contact Info</h3>
               <ul className="space-y-6 m-0 p-0 list-none flex-grow">
                 <li className="flex items-start gap-4">
                   <div className="w-10 h-10 rounded-full bg-cream-dark flex items-center justify-center shrink-0 text-crimson text-xl transition-colors hover:bg-crimson hover:text-white">
                     <Icon icon="ep:location" />
                   </div>
                   <div className="text-[0.9rem] font-light text-charcoal/80 leading-relaxed pt-1">
                     <strong className="font-medium text-charcoal block mb-0.5">Office:</strong> 
                     First Floor, Sterling Bank Plaza, Central Business District, Abuja, 900103
                   </div>
                 </li>
                 <li className="flex items-start gap-4">
                   <div className="w-10 h-10 rounded-full bg-cream-dark flex items-center justify-center shrink-0 text-crimson text-xl transition-colors hover:bg-crimson hover:text-white">
                     <Icon icon="fluent:call-24-regular" />
                   </div>
                   <div className="text-[0.9rem] font-light text-charcoal/80 leading-relaxed pt-1">
                     <strong className="font-medium text-charcoal block mb-0.5">Phone:</strong> 
                     +234 803 873 8245
                   </div>
                 </li>
                 <li className="flex items-start gap-4">
                   <div className="w-10 h-10 rounded-full bg-cream-dark flex items-center justify-center shrink-0 text-crimson text-xl transition-colors hover:bg-crimson hover:text-white">
                     <Icon icon="bi:envelope" />
                   </div>
                   <div className="text-[0.9rem] font-light text-charcoal/80 leading-relaxed pt-1">
                     <strong className="font-medium text-charcoal block mb-0.5">Email:</strong> 
                     contact@nooohraservices.org
                   </div>
                 </li>
               </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
